module.exports = __webpack_public_path__ + "resources/img/solution_game_consulting.9c96cc2cadb58754f1457f524f870271.png";